<div class="bg-gray-200 br-15 p-3 mb-4">
    <form name="form" [formGroup]="form" (ngSubmit)="saveProfile()">
        <div class="row">
            <div class="col-12 mb-4">
                <mat-radio-group aria-label="gender" formControlName="gender">
                    <mat-radio-button value="MALE" class="mr-4">
                        <span class="avatar d-flex align-items-center justify-content-center">
                            <img src="./assets/images/man-avatar.svg" alt="Male" title="Male" />
                        </span>
                    </mat-radio-button>
                    <mat-radio-button value="FEMALE">
                        <span class="avatar d-flex align-items-center justify-content-center">
                            <img
                                src="./assets/images/girl-avatar.svg"
                                alt="Female"
                                title="Female"
                                width="55"
                            />
                        </span>
                    </mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError:
                            form.get('firstName').errors && form.get('firstName').touched
                    }"
                >
                    <input
                        matInput
                        formControlName="firstName"
                        type="text"
                        placeholder="First Name"
                    />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'firstName'"> </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError: form.get('lastName').errors && form.get('lastName').touched
                    }"
                >
                    <input
                        matInput
                        formControlName="lastName"
                        type="text"
                        placeholder="Last Name"
                    />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'lastName'"> </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError: form.get('email').errors && form.get('email').touched
                    }"
                >
                    <input matInput formControlName="email" type="text" placeholder="Email" />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'email'"> </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field class="form-group dark-input">
                    <input
                        matInput
                        [matDatepicker]="dobPicker"
                        [max]="today"
                        formControlName="dob"
                        placeholder="Date of birth"
                    />
                    <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                    <mat-datepicker #dobPicker startView="multi-year"></mat-datepicker>
                    <mat-error *ngIf="form.get('dob').hasError('matDatepickerMax')">
                        Date of birth can't be in the future.
                    </mat-error>
                    <mat-error *ngIf="form.get('dob').hasError('matDatepickerParse')">
                        Enter the date as DD/MM/YYYY.
                    </mat-error>
                    <mat-error
                        *ngIf="form.get('dob').hasError('required') && !form.get('dob').hasError('matDatepickerParse')"
                    >
                        Date of birth is required.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 mb-4">
                <a class="ml-2" (click)="onChangePassword()">Click to change Password</a>
            </div>
            <div class="col-12 col-lg-6 mb-4" *ngIf="editPassword">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError: form.get('password').errors && form.get('password').touched
                    }"
                >
                    <input
                        matInput
                        formControlName="password"
                        type="password"
                        placeholder="Password"
                    />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'password'"> </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4" *ngIf="editPassword">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError:
                            form.get('password_confirmation').errors &&
                            form.get('password_confirmation').touched
                    }"
                >
                    <input
                        matInput
                        formControlName="password_confirmation"
                        type="password"
                        placeholder="Confirm Password"
                    />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'password_confirmation'">
                </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field class="form-group dark-input">
                    <mat-label>Country</mat-label>
                    <mat-select
                        formControlName="country"
                        panelClass="select-panel-down"
                        [disableOptionCentering]="true"
                    >
                        <mat-option
                            *ngFor="let country of countries"
                            [value]="country.label"
                            class="text-capitalize"
                        >
                            {{ country.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'country'"> </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError: form.get('city').errors && form.get('city').touched
                    }"
                >
                    <input matInput formControlName="city" type="text" placeholder="City" />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'city'"> </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError: form.get('street').errors && form.get('street').touched
                    }"
                >
                    <input matInput formControlName="street" type="text" placeholder="Street" />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'street'"> </app-error-input>
            </div>
            <div class="col-12 col-lg-6 mb-4">
                <mat-form-field
                    class="form-group dark-input"
                    [ngClass]="{
                        validationError: form.get('building').errors && form.get('building').touched
                    }"
                >
                    <input
                        matInput
                        formControlName="building"
                        type="text"
                        placeholder="Building/Floor"
                    />
                </mat-form-field>
                <app-error-input [form]="form" [controlName]="'building'"> </app-error-input>
            </div>
        </div>

        <div class="w-100">
            <button class="btn btn-lg btn-gray-500 float-right" [disabled]="!form.valid">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                save
            </button>
            <div class="clearfix"></div>
        </div>
    </form>
</div>
